// extracted by mini-css-extract-plugin
export var dayLabel = "_iv-0";
export var pickerDisabled = "_iv-1";